import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './BannerSection.css';
import Button from '../../../common/components/Button/Button';

export default function BannerSectionPresentation() {
  useStyles(s);
  return (
    <div className={s.bannerContainer}>
      <div className={s.contentContainer}>
        <h1 className={s.title}>از خودت سبقت بگیر!</h1>
        <p className={s.description}>
          اگر مشتاق یادگیری هستید، دوست دارید رشد کنید و از خودتان هم فراتر بروید، اینجا فرصت برای سبقت گرفتن از خودتان فراهم است،
          چرا که سرعت رشد و یادگیری در تپسی بسیار بالاست. یادگیری مفیدی که از حل کردن چالش‌های جذاب در کنار یک تیم متخصص و حرفه‌ای
          حاصل می‌شود.
        </p>
        <a href="/jobs">
          <Button theme="white-theme">پیوستن به تپسی</Button>
        </a>
      </div>
    </div>
  );
}
